import appEnv from 'bundles/accomplishments/appEnv';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
